import {
  WEBINR_USER_REGISTRATION_REQUEST, WEBINR_USER_REGISTRATION_SUCCEDDED, WEBINR_USER_REGISTRATION_FAILED
} from '../../actions/actionTypes.jsx';


const initialState = {
  loading: false,
  invalidated: false,
  item: null,
  error: null
}

function webinrIntegrationReducer(state = initialState, action) {
  switch (action.type) {
    case WEBINR_USER_REGISTRATION_REQUEST:
      return Object.assign({}, state, {
        ...state,
        loading: true,
        invalidated: true
      })
    case WEBINR_USER_REGISTRATION_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        loading: false,
        invalidated: false,
        item: action.payload
      });

    case WEBINR_USER_REGISTRATION_FAILED:
      return Object.assign({}, state, {
        ...state,
        loading: false,
        invalidated: false,
        error: action.payload.error
      })
    default:
      return state
  }
}

export { webinrIntegrationReducer };